export const TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
export const SITE_KEY = '6LcmK_EUAAAAAN18oGHoIpnio-3hThnSRJj-_o8K';
export const TAX = 1.11;
